<template>
  <div class="main-box">
    <full-page
      :options="options"
      ref="fullpage"
      class="fp-auto-height-responsive"
    >
      <div class="section">
        <div class="index-box">
          <div class="row">
            <div
              class="col-mid-1 col-xis-1"
              v-for="(item, index) in sourceList"
              :key="index"
            >
              <img
                :src="item.url"
                alt="招鲤视频"
                title="招鲤视频"
                v-if="item.type == 'img'"
              />
              <video
                :src="item.url"
                autoplay="true"
                class="source-video"
                loop="true"
                muted
                v-else
              ></video>
            </div>

            <div class="mask-box"></div>
            <div class="content-box" v-if="sate">
              <div class="title">{{ $t("index.content") }}</div>
              <div class="title">{{ $t("index.contentInfo") }}</div>
              <img
                class="play-btn"
                src="https://p.cdn.izhaoli.cn/official_website/website/video.gif"
                alt="播放"
                title="点击播放"
                @click="goNext(1)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="desc-box">
          <div class="content-box2">
            <div class="background-box"></div>
            <img
              class="culture-img content-img"
              src="https://p.cdn.izhaoli.cn/official_website/website/red.png"
              alt="我们的文化"
              title="我们的文化"
            />
            <div class="content-title">{{ $t("index.cultureTitle") }}</div>
            <div class="content-info">{{ $t("index.culture") }}</div>
            <a @click="goNext(2)">
              <img
                class="next-icon"
                src="https://p.cdn.izhaoli.cn/official_website/website/next-icon@2x.png"
                alt="下拉箭头"
                title="下拉箭头"
              />
            </a>
          </div>
          <div class="right-img right-img-culture"></div>
        </div>
      </div>
      <div class="section">
        <div class="desc-box">
          <div class="content-box2">
            <div class="background-box"></div>
            <img
              class="poster-img content-img"
              src="https://p.cdn.izhaoli.cn/official_website/website/green.png"
              alt="招鲤海报"
              title="招鲤海报"
            />
            <div class="content-title">{{ $t("index.posterTitle") }}</div>
            <div class="content-info">{{ $t("index.poster") }}<a :href="jollytodaySiteUrl" target="_blank">{{$t('index.go')}}</a></div>
            <a @click="goNext(3)">
              <img
                class="next-icon"
                src="https://p.cdn.izhaoli.cn/official_website/website/next-icon@2x.png"
                alt="下拉箭头"
                title="下拉箭头"
              />
            </a>
          </div>
          <!-- <img
            class="right-img"
            src="https://p.cdn.izhaoli.cn/official_website/website/Zhaoli Video-bg@2x.png"
            alt="招鲤海报"
            title="招鲤海报"
          />-->
          <div class="right-img right-img-video"></div>
        </div>
      </div>
      <div class="section">
        <div class="desc-box">
          <div class="content-box2">
            <div class="background-box"></div>
            <img
              class="video-img content-img"
              src="https://p.cdn.izhaoli.cn/official_website/website/Violet.png"
              alt="招鲤短视频"
              title="招鲤短视频"
            />
            <div class="content-title">{{ $t("index.videoTitle") }}</div>
            <div class="content-info">{{ $t("index.video") }}</div>
            <a @click="goNext(4)">
              <img
                class="next-icon"
                src="https://p.cdn.izhaoli.cn/official_website/website/next-icon@2x.png"
                alt="下拉箭头"
                title="下拉箭头"
              />
            </a>
          </div>
          <!-- <img
            class="right-img"
            src="https://p.cdn.izhaoli.cn/official_website/website/Zhaoli Go-bg@2x.png"
            alt="招鲤短视频"
            title="招鲤短视频"
          />-->
          <div class="right-img right-img-go"></div>
        </div>
      </div>
      <div class="section">
        <div class="desc-box">
          <div class="content-box2">
            <div class="background-box"></div>
            <img
              class="join-img content-img"
              src="https://p.cdn.izhaoli.cn/official_website/website/blue.png"
              alt="加入我们"
              title="加入我们"
            />
            <div class="content-title">{{ $t("index.joinTitle") }}</div>
            <div class="content-info">{{ $t("index.join") }}</div>
            <!-- <a href="mailto:niumo@izhaoli.com" class="email-info">
              <i class="iconfont icon-xinfeng"></i> niumo@izhaoli.com
            </a>-->
            <img
              class="email-img"
              src="https://p.cdn.izhaoli.cn/official_website/website/emial-icon@2x.png"
              alt="加入我们"
              title="加入我们"
            />
          </div>
          <!-- <img
            class="right-img"
            src="https://p.cdn.izhaoli.cn/official_website/website/Join Us-bg@2x.png"
            alt="加入我们"
            title="加入我们"
          />-->
          <div class="right-img right-img-join"></div>
        </div>
      </div>
    </full-page>

    <div class="swiper-box" v-if="current != 0">
      <img
        class="play-img"
        v-if="playState"
        src="https://p.cdn.izhaoli.cn/official_website/website/播放-icon@2x.png"
        @click="playVideo(phoneCurrentIndex)"
      />
      <img
        class="phone-img"
        src="https://p.cdn.izhaoli.cn/official_website/website/iphone.png"
        @click="playVideo(phoneCurrentIndex)"
      />
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <video
              class="swiper-video"
              src="https://p.cdn.izhaoli.cn/official_website/website/culture.mp4"
            ></video>
          </div>
          <div class="swiper-slide">
            <video
              class="swiper-video"
              src="https://p.cdn.izhaoli.cn/gc/video/clip1.mp4"
            ></video>
          </div>
          <div class="swiper-slide">
            <video
              class="swiper-video"
              src="https://p.cdn.izhaoli.cn/official_website/website/C.mp4"
            ></video>
          </div>
          <div class="swiper-slide">
            <video
              class="swiper-video"
              src="https://p.cdn.izhaoli.cn/official_website/website/joinUs.mp4"
            ></video>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="phone-box" v-if="current>0">
      <img class="phone-img" src="@/assets/iphone.png" />

      <div class="phone-content">
      <img src="https://p.cdn.izhaoli.cn/official_website/website/img-08.png" mode="aspectFill" />
        <video src="@/assets/video1.mp4" autoplay loop="true" height="500"></video>
      </div>
    </div>-->

    <div class="footer-box">
      <div>
        2019 © {{ $t("index.Abbreviation") }} |
        <a href="http://www.beian.miit.gov.cn">{{ $t("index.RecordInfo") }}</a>
        | {{ $t("index.company") }} | 产品：
        <a
         
          target="_blank"
          :href="jollytodaySiteUrl"
        >
          GhostCut</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  computed: {
    jollytodaySiteUrl() {
      return this.$i18n.locale == "en"?"https://jollytoday.com/":"https://cn.jollytoday.com/";
    }
  },
  data() {
    var myData = {
      options: {
        licenseKey: "", //许可密钥
        afterLoad: this.afterLoad, //滚动到某一屏后的回调函数
        onLeave: this.onLeave, //滚动前的回调函数，
        anchors: ["Zhaoli", "OurCulture", "ZhaoliVideo", "ZhaoliGo", "JoinUs"],
        animateAnchor: true,
        scrollBar: true, //true则是一滚动就是一整屏
        sectionsColor: ["#202020", "#202020", "#202020", "#202020", "#202020"], //每个section设置background-color属性
      },
      current: 0,
      phoneCurrentIndex: 0,
      playState: true,
      sate: true,
      sourceList: [
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-01.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频01_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-02.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-03.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-04.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-05.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频02_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-06.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-07.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-08.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-09.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频03_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-10.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-11.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频04_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-12.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-13.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-14.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-15.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-16.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-17.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-18.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频05_2.mp4",
          type: "video",
        },

        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-19.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-20.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-21.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频02_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-23.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-07.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-21.png",
          type: "img",
        },

        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-19.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-07.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-01.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-13.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-05.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-12.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-01.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-02.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频01_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-14.png",
          type: "img",
        },

        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-01.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-10.png",
          type: "img",
        },
        {
          url:
            "https://p.cdn.izhaoli.cn/official_website/website/首屏视频05_2.mp4",
          type: "video",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-19.png",
          type: "img",
        },
        {
          url: "https://p.cdn.izhaoli.cn/official_website/website/img-06.png",
          type: "img",
        },
      ],
      swiper: "",
    };
    if (document.body.clientWidth < 750) {
      let sourceList = [];
      for (let i in myData.sourceList) {
        if (
          myData.sourceList[i] &&
          myData.sourceList[i].type &&
          myData.sourceList[i].type != "video"
        ) {
          sourceList.push(myData.sourceList[i]);
        }
      }
      myData.sourceList = sourceList;
    }

    return myData;
  },
  mounted() {
    this.autoPlayVideo();
  },
  updated() {
    this.autoPlayVideo();
  },
  methods: {
    swiperChange() {
      this.swiper = new Swiper(".swiper-container", {
        direction: "vertical",
        observer: true,
        observeParents: true,
      });
    },

    //自动播放
    autoPlayVideo() {
      var videoList = document.getElementsByClassName("source-video");
      for (var i in videoList) {
        typeof videoList[i].play == "function" && videoList[i].play();
      }
    },

    //点击播放
    playVideo(index) {
      var videoList = document.getElementsByClassName("swiper-video");

      this.playState = !this.playState;

      console.log(this.playState);

      if (!this.playState) {
        typeof videoList[index].play == "function" && videoList[index].play();
      } else {
        videoList[index].pause();
      }
    },

    onLeave(e) {
      if (e.index == 0) {
        this.sate = false;
      }
    },

    afterLoad(origin, destination) {
      try {
        this.current = destination.index;
        if (destination.index == 0) {
          this.sate = true;
        }
        this.swiperChange();
        this.phoneCurrentIndex = this.current - 1;
        this.playState = true;
        // console.log(
        //   this.phoneCurrentIndex,
        //   this.swiper.activeIndex,
        //   this.swiper.realIndex,
        //   this.swiper.previousIndex,
        //   this.swiper.isBeginning
        // );
        // if ((this.phoneCurrentIndex - 1)<=0) {
        //   console.log(222)
        // this.swiper.slidePrev(250,false)
        // } else {
        // this.swiper.slideTo(this.phoneCurrentIndex-1, 250, false);
        // }

        if (this.phoneCurrentIndex > 0) {
          this.swiper.slideTo(this.phoneCurrentIndex, 250, false);
        } else if (this.phoneCurrentIndex == 0) {
          this.swiper.slideReset(250, false);
          this.swiper.update();
        }

        var videoList = document.getElementsByClassName("swiper-video");

        for (var i in videoList) {
          if (
            videoList[i] &&
            videoList[i].played &&
            videoList[i].played.length &&
            videoList[i].played.length > 0
          ) {
            videoList[i].load();
          }
        }
      } catch (e) {}
    },

    goNext(page) {
      switch (page) {
        case 1:
          fullpage_api.moveTo("OurCulture", 2);
          break;
        case 2:
          fullpage_api.moveTo("ZhaoliVideo", 2);
          break;
        case 3:
          fullpage_api.moveTo("ZhaoliGo", 2);
          break;
        case 4:
          fullpage_api.moveTo("JoinUs", 2);
          break;
      }
    },
  },
};
</script>

<style scoped>
/* //////////////// swiper 轮播 ////////////////// */
.swiper-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 200;
  animation: slideInto 0.25s ease 1;
}
@keyframes slideInto {
  0% {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, 0%);
    opacity: 1;
  }
}
.swiper-container {
  z-index: 1;
  width: 293px;
  height: 595px;
  border-radius: 48px;
  overflow: hidden;
}
.swiper-slide {
  width: 295px;
  height: 595px;
  border-radius: 48px;
  background: #000;
}
.swiper-slide img,
.swiper-slide video {
  width: 100%;
  height: 100%;
}
.play-img {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
}
.phone-img {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
}
.phone-content {
  position: absolute;
  top: 2px;
  transform: translateX(-50%);
  z-index: 1;
  width: 295px;
  height: 595px;
  border-radius: 40px;
  overflow: hidden;
}
.phone-content img,
.phone-content video {
  width: 100%;
  height: 100%;
}

/* ////////////////////////////////// */

.index-box,
.desc-box {
  position: relative;
}

.section {
  overflow: hidden !important;
}

.content-box {
  font-size: 36px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  animation: slideInto 0.1s ease 1;
}
@keyframes slideInto {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.content-box2 {
  width: 50%;
  height: 100%;
  padding: 200px;
}

.row {
  position: relative;
}
.mask-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.row img {
  width: 100%;
  height: 300px;
}
.mask-img {
  width: 230px;
  height: 300px;
}

.main-box {
  position: relative;
}
.email-info {
  display: block;
  width: 206px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  color: #fff;
  font-size: 16px;
  display: flex;
  text-align: center;
  line-height: 32px;
  margin: 30px 0;
}

.email-img {
  width: 206px !important;
  height: 32px !important;
  position: relative;
  z-index: 20;
  margin-top: 30px;
}
.content-title {
  font-size: 64px;
  font-weight: 500;
  margin-bottom: 80px;
  position: relative;
  z-index: 999;
}
.play-btn {
  width: 120px !important;
  height: 120px !important;
  margin-top: 80px;
}
.footer-box {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 30px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  z-index: 20;
}
.footer-box a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}
.footer-box a:hover {
  color: rgba(255, 255, 255, 0.7);
}
.content-info {
  position: relative;
  z-index: 20;
}
.background-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 80px;
  background: url("https://p.cdn.izhaoli.cn/official_website/website/black-bg.png");
  z-index: 1;
}
.next-icon {
  position: relative;
  z-index: 20;
}
/* 右侧图片 */
.right-img {
  width: 50%;
  height: 100%;
  background-size: cover;
  position: relative;
  z-index: 20;
}
.right-img-culture {
  background: url("https://p.cdn.izhaoli.cn/official_website/website/Our Culture-bg.png")
    no-repeat center right;
  background-size: cover;
}
.right-img-video {
  background: url("https://p.cdn.izhaoli.cn/official_website/website/Zhaoli Video-bg.png")
    no-repeat center right;
  background-size: cover;
}
.right-img-go {
  background: url("https://p.cdn.izhaoli.cn/official_website/website/Zhaoli Go-bg.png")
    no-repeat center right;
  background-size: cover;
}
.right-img-join {
  background: url("https://p.cdn.izhaoli.cn/official_website/website/Join Us-bg.png")
    no-repeat center right;
  background-size: cover;
}
/* ------------------- 屏幕兼容 --------------------------- */

@media screen and (min-width: 1920px) {
  .col-mid-1 {
    width: 11.111111% !important;
  }
  .col-mid-1 img,
  .col-mid-1 video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .desc-box {
    height: 100%;
    color: #ffff;
    font-size: 18px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    /* background: url("https://p.cdn.izhaoli.cn/official_website/website/black-bg.png"); */
  }

  .content-box2 a {
    display: block;
  }
  .next-icon {
    width: 50px;
    height: 50px;
    margin-top: 60px;
  }
  .culture-img {
    width: 190px !important;
    height: 100px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
  .poster-img {
    width: 169px !important;
    height: 251px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
  .video-img {
    width: 248px !important;
    height: 134px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
  .join-img {
    width: 152px !important;
    height: 138px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
}
@media (max-width: 1920px) {
  .col-mid-1 {
    width: 11.111111% !important;
  }
  .col-mid-1 img,
  .col-mid-1 video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .desc-box {
    height: 100%;
    color: #ffff;
    font-size: 18px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    /* background: url("https://p.cdn.izhaoli.cn/official_website/website/black-bg.png"); */
  }
  .desc-box img {
    width: 55%;
    height: 101%;
  }
  .content-box {
    width: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 10;
    padding: 0 50px !important;
    text-align: center;
  }

  .content-box2 a {
    display: block;
  }
  .next-icon {
    width: 50px !important;
    height: 50px !important;
    margin-top: 60px !important;
  }
  .culture-img {
    width: 190px !important;
    height: 100px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
  .poster-img {
    width: 169px !important;
    height: 251px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
  .video-img {
    width: 248px !important;
    height: 134px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
  .join-img {
    width: 152px !important;
    height: 138px !important;
    position: absolute;
    left: 30px;
    margin-top: 0 !important;
    z-index: 30;
  }
}
@media (max-width: 1670px) {
  .content-title {
    font-size: 38px;
  }
}
@media (max-width: 1300px) {
  .content-title {
    font-size: 32px;
  }
}
@media (max-width: 1210px) {
  .col-mid-1 {
    width: 14.28% !important;
  }
  .content-title {
    font-size: 24px;
  }
  .desc-box {
    height: 100%;
    color: #ffff;
    font-size: 18px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    /* background: url("https://p.cdn.izhaoli.cn/official_website/website/black-bg.png"); */
  }
  .desc-box img {
    width: 55%;
    height: 101%;
  }
  .next-icon {
    width: 50px !important;
    height: 50px !important;
    margin-top: 60px !important;
  }
}
@media (max-width: 1110px) {
  /* .title {
    font-size: calc(3.5rem);
  } */
  .content-title {
    font-size: 18px;
  }
  .col-mid-1 {
    width: 20% !important;
  }
  .content-box2 {
    width: 40%;
    padding: 300px 50px !important;
  }
  .play-btn {
    width: 120px !important;
    height: 120px !important;
  }
  .content-title {
    font-size: 48px;
  }
  .desc-box {
    font-size: 30px;
  }
  .culture-img {
    width: 140px !important;
    height: 50px !important;
    position: absolute;
    left: 30px;
    top: 180px;
    margin-top: 0 !important;
  }
  .poster-img {
    width: 110px !important;
    height: 200px !important;
    position: absolute;
    left: 190px;
    top: 70px;
    margin-top: 0 !important;
  }
  .video-img {
    width: 200px !important;
    height: 80px !important;
    position: absolute;
    left: 30px;
    top: 160px;
    margin-top: 0 !important;
  }
  .join-img {
    width: 110px !important;
    height: 90px !important;
    position: absolute;
    left: 180px;
    margin-top: 0 !important;
  }
}
@media (max-width: 960px) {
  .content-title {
    font-size: 15px;
  }
  .col-mid-1 {
    width: 20% !important;
  }
  .content-box2 {
    width: 35%;
    padding: 200px 50px !important;
  }
  .content-title {
    font-size: 33px;
  }
  .culture-img {
    width: 140px !important;
    height: 50px !important;
    position: absolute;
    left: 30px;
    top: 120px;
    margin-top: 0 !important;
  }
  .poster-img {
    width: 110px !important;
    height: 200px !important;
    position: absolute;
    left: 190px;
    top: 70px;
    margin-top: 0 !important;
  }
  .video-img {
    width: 200px !important;
    height: 80px !important;
    position: absolute;
    left: 30px;
    top: 120px;
    margin-top: 0 !important;
  }
  .join-img {
    width: 110px !important;
    height: 90px !important;
    position: absolute;
    left: 180px;
    top: 120px;
    margin-top: 0 !important;
  }
}
@media (max-width: 900px) {
  .content-title {
    font-size: 30px;
  }
}
@media (max-width: 769px) {
  .content-title {
    font-size: 29px;
  }
  .col-mid-1 {
    width: 25% !important;
  }
  .content-box2 {
    width: 35%;
    padding: 250px 40px !important;
  }

  .desc-box {
    font-size: 20px;
  }
  .email-info {
    width: 183px;
  }
}
@media (max-width: 750px) {
  .right-img {
    width: 100%;
  }
  .swiper-box,
  .phone-img,
  .phone-content,
  .swiper-slide {
    display: none;
  }
  .content-box {
    width: 100%;
    font-size: 36px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 10;
    padding: 0 50px !important;
    text-align: center;
  }
  .title {
    font-size: 24px;
  }
  .content-box2 {
    width: 100%;
    padding: 0 36px !important;
    position: absolute;
    top: 150px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 50;
  }
  .background-box {
    display: none;
  }
  .next-icon {
    width: 50px;
    height: 50px;
    position: absolute;
    bottom: 240px !important;
    left: 50%;
    transform: translateX(-50%);
  }

  .content-title {
    font-size: 45px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 80px;
  }
  .content-img {
    width: 0px !important;
    height: 0px !important;
    margin-top: 0 !important;
  }

  .email-info {
    margin: 30px auto !important;
  }
  .footer-box {
    bottom: 10px;
  }
}
@media (max-width: 420px) {
  /* .title {
    font-size: calc(1.3rem);
  } */
  .swiper-box,
  .phone-img,
  .phone-content,
  .swiper-slide {
    display: none;
  }
  .row img {
    height: 250px;
  }
  .col-xis-1 {
    width: 33.33333% !important;
  }
  .content-title {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 80px;
  }
  .content-box2 {
    width: 100%;
    padding: 0 36px !important;
    position: absolute;
    top: 150px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 50;
  }
  .background-box {
    display: none;
  }
  .next-icon {
    width: 50px;
    height: 50px;
    position: absolute;
    bottom: 215px;
    left: 50%;
    transform: translateX(-50%);
  }

  .content-title {
    font-size: 45px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 80px;
  }
  /* .right-img {
    width: 125% !important;
    position: absolute;
    clip: rect(0px, 750px, 750px, 100px);
    top: 0;
    left: 0;
    z-index: 5;
    margin-left: -100px;
    transform: scale(1);
  } */
  .content-img {
    width: 0px !important;
    height: 0px !important;
    margin-top: 0 !important;
  }

  .email-info {
    margin: 30px auto !important;
  }
}
@media (max-width: 375px) {
  .swiper-box,
  .phone-img,
  .phone-content,
  .swiper-slide {
    display: none;
  }
  .content-box2 {
    width: 100%;
    padding: 0 36px;
    position: absolute;
    top: 150px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 50;
  }
  .background-box {
    display: none;
  }
  .next-icon {
    width: 50px;
    height: 50px;
    position: absolute;
    bottom: 215px;
    left: 50%;
    transform: translateX(-50%);
  }

  .content-title {
    font-size: 45px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 80px;
  }
  /* .right-img {
    width: 125% !important;
    position: absolute;
    clip: rect(0px, 750px, 750px, 85px);
    top: 0;
    left: 0;
    z-index: 5;
    margin-left: -85px;
  } */
  .email-info {
    margin: 30px auto !important;
  }
}
</style>
